"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpPanel = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const panel_html_1 = __importDefault(require("./panel.html"));
let ItpPanel = class ItpPanel extends vue_1.default {
    isExpanded;
    collapsible;
    caption;
    stateKey;
    carousel;
    initialState;
    data() {
        return {
            isExpanded: this.getIsExpanded()
        };
    }
    onIsExpandedChange(isExpanded) {
        if (this.collapsible && this.stateKey) {
            this.$app.objectStore.setItem(`panel.${this.stateKey}`, { isExpanded });
        }
    }
    get className() {
        return {
            'itp-panel': true,
            'w-100': true,
            collapsible: this.collapsible,
            expanded: this.isExpanded
        };
    }
    get iconName() {
        if (this.carousel) {
            return this.isExpanded
                ? 'material-symbols:expand-all'
                : 'material-symbols:collapse-all';
        }
        return this.isExpanded ? 'fa-angle-down' : 'fa-angle-right';
    }
    onClick() {
        this.isExpanded = !this.isExpanded;
    }
    getIsExpanded() {
        if (this.collapsible && this.stateKey) {
            const value = this.$app.objectStore.getItem(`panel.${this.stateKey}`, null);
            if (value && _.isBoolean(value.isExpanded)) {
                return value.isExpanded;
            }
        }
        return this.initialState === 'expanded';
    }
};
exports.ItpPanel = ItpPanel;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpPanel.prototype, "collapsible", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: String }),
    __metadata("design:type", String)
], ItpPanel.prototype, "caption", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: String }),
    __metadata("design:type", String)
], ItpPanel.prototype, "stateKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpPanel.prototype, "carousel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'expanded', type: String }),
    __metadata("design:type", String)
], ItpPanel.prototype, "initialState", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isExpanded'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ItpPanel.prototype, "onIsExpandedChange", null);
exports.ItpPanel = ItpPanel = __decorate([
    (0, vue_property_decorator_1.Component)({ template: panel_html_1.default })
], ItpPanel);
//# sourceMappingURL=panel.js.map